import React, {useEffect, useRef, useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { push } from "connected-react-router";

import LinkMIcon from '@mui/icons-material/Link';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { styled, Tooltip } from '@mui/material';

const PREFIX = 'LinkIcon';

const classes = {
    root: `${PREFIX}-root`,
    linkPopover: `${PREFIX}-linkPopover`
};

// TODO jss-to-styled codemod: The Fragment root was replaced by div. Change the tag if needed.
const Root = styled('div')((
    {
        theme
    }
) => ({
    [`& .${classes.root}`]: {
		height: '100%',
		width: '100%'
	},

    [`& .${classes.linkPopover}`]: {
		// position: 'absolute',	// commented out to support scrolling on a Table (/swmm/run/calibration%20versions) with icons stuck in place
		color: theme.palette.grey[500],
		zIndex: 99,
		cursor: 'pointer'
	}
}));

export default function LinkIcon({link}) {
	const dispatch = useDispatch();

	const [internalLink, setInternalLink] = useState(true);

	useEffect(() => {
		// Determine if this is a link to route
		// within the application or an external link
		// to open in a new window
		if (link.href) {
			if (link.href.toLowerCase().indexOf('http') === 0) {
				setInternalLink(false);
			} else {
				setInternalLink(true);
			}
		}

	}, [link]);

	const navigateRoute = () => {
		dispatch(push('{0}'.format(link.href)));
	}

	const newWindowTab = () => {
		window.open(link.href, "_blank");
	}

	const disabled = link?.tooltip !== undefined ? false : true;

	return (
        <Root>
			{link.href && internalLink &&
				<Tooltip title={link?.tooltip} disableHoverListener={disabled} disableFocusListener={disabled} disableTouchListener={disabled}>
					<ExitToAppIcon onClick={navigateRoute} fontSize="small" style={{...link.button}} className={classes.linkPopover}/>
				</Tooltip>
			}
			{link.href && !internalLink &&
				<Tooltip title={link?.tooltip} disableHoverListener={disabled} disableFocusListener={disabled} disableTouchListener={disabled}>
					<LinkMIcon onClick={newWindowTab} fontSize="small" style={{...link.button}} className={classes.linkPopover}/>
				</Tooltip>
			}
		</Root>
    );

}
